import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-capp_mechanism",
  "use": "icon-capp_mechanism-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 22\" fill=\"none\" id=\"icon-capp_mechanism\">\n  <path d=\"M0.400024 2.36005H19.6V0.200048H0.400024V2.36005ZM11.0667 13.16H18.5334L10 4.52005L1.46669 13.16H8.93336V21.8H11.0667V13.16Z\" fill=\"#A563FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol